import { render, staticRenderFns } from "./Clean.vue?vue&type=template&id=5de2f5b1"
import script from "./Clean.vue?vue&type=script&lang=js"
export * from "./Clean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports